module.exports = __webpack_public_path__ + "static/media/FlagBGMobile.ad76cc0b.png";